export default "__VITE_ASSET__DjmS8Cpm__"